import { render, staticRenderFns } from "./HeaderGeneral.vue?vue&type=template&id=c627680c"
import script from "./HeaderGeneral.vue?vue&type=script&lang=js"
export * from "./HeaderGeneral.vue?vue&type=script&lang=js"
import style0 from "./HeaderGeneral.vue?vue&type=style&index=0&id=c627680c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports